import { Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faUser, IconDefinition } from '@fortawesome/pro-solid-svg-icons';

@Component({
    selector: 'fdx-system-user-avatar',
    templateUrl: './system-user-avatar.component.html',
    styleUrls: ['../user-avatar.scss', './system-user-avatar.component.scss'],
    standalone: true,
    imports: [
        FontAwesomeModule
    ]
})
export class SystemUserAvatarComponent {
    @Input() hasNotifications: boolean = false;
    @Input() userLoaded: boolean;
    @Input() firstName: string;
    @Input() lastName: string;

    readonly userIcon: IconDefinition = faUser;

    get initials(): string {
        if (!this.firstName || !this.lastName) {
            return '';
        }

        return (this.firstName.substring(0, 1) + this.lastName.substring(0, 1)).toUpperCase();
    }
}
